import TableEmptyIndicator from "./TableEmptyIndicator.js";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgress from "@mui/material/CircularProgress";
import { t } from "i18next";
// import { components } from "react-select";

// const { LoadingIndicator } = components;
// const props = {
//   getStyles: () => ({}), // required
//   getClassNames: () => "",
//   cx: () => "",
// };

const InfiniteTable = ({
  children,
  count,
  isLoading,
  isFetchingNextPage,
  hasMore,
  noDataMessage,
  ...rest
}) => {
  return (
    <div className="w-full h-full relative">
      <InfiniteScroll
        {...rest}
        hasMore={hasMore}
        loader={
          hasMore && isFetchingNextPage ? (
            <div className="w-full text-left justify-center items-center p-4">
              {t("_Loading...")}
            </div>
          ) : (
            ""
          )
        }
      >
        {children}
      </InfiniteScroll>
      {isLoading && (
        <div
          className="flex justify-center flex-col border-none items-center text-gray-500 font-semibold absolute left-0 bottom-0 right-0"
          style={{
            top: "52.4px",
          }}
        >
          <CircularProgress />
          <div>{t("_Loading...")}</div>
        </div>
      )}
      {!isLoading && !(count > 0) && (
        <TableEmptyIndicator message={noDataMessage} />
      )}
    </div>
  );
};

export default InfiniteTable;
